import moment from 'moment';

export function isValidDate(date: any): boolean {
  const formats = [moment.ISO_8601, 'DD/MM/YYYY', 'MM/DD/YYYY'];

  return moment(date, formats, true).isValid();
}
